module.exports = __webpack_public_path__ + "media/images/icons/external-link-arrow-square-up-right-white-88a0afc67d78f73826eb51a83c68bc84.svg";